import React from 'react';

function Process() {
  return (
    <section className="process section-padding">
      <div className="container">
        <div className="sec-head mb-80">
          <h6 className="sub-title main-color mb-25">Our Process</h6>
          <div className="bord pt-25 bord-thin-top d-flex align-items-center">
            <h2 className="fw-600">
              Business <span className="fw-200">Development</span>
            </h2>
            <div className="ml-auto">
              <a href="/light/page-about2" className="go-more">
                <span className="text">View More</span>
                <span className="icon ti-arrow-top-right"></span>
              </a>
            </div>
          </div>
        </div>
        <div className="row md-marg">
          <div className="col-lg-3 col-md-6 item md-mb50">
            <div className="icon-img-60 mb-30">
              <img src="/light/assets/imgs/serv-icons/3.png" alt="" />
            </div>
            <h5 className="mb-15">Research</h5>
            <p>
              Clarifying and translating insights into foundation and creative
              approach
            </p>
            <div className="o-hidden">
              <a href="/light/page-about2" className="rmore to-in mt-30">
                <span className="sub-title">Read More</span>
                <img
                  src="/light/assets/imgs/arrow-right.png"
                  alt=""
                  className="icon-img-20 ml-5"
                />
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 item md-mb50">
            <div className="icon-img-60 mb-30">
              <img src="/light/assets/imgs/serv-icons/4.png" alt="" />
            </div>
            <h5 className="mb-15">Concept</h5>
            <p>
              Clarifying and translating insights into foundation and creative
              approach
            </p>
            <div className="o-hidden">
              <a href="/light/page-about2" className="rmore to-in mt-30">
                <span className="sub-title">Read More</span>
                <img
                  src="/light/assets/imgs/arrow-right.png"
                  alt=""
                  className="icon-img-20 ml-5"
                />
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 item sm-mb50">
            <div className="icon-img-60 mb-30">
              <img src="/light/assets/imgs/serv-icons/5.png" alt="" />
            </div>
            <h5 className="mb-15">Implement</h5>
            <p>
              Clarifying and translating insights into foundation and creative
              approach
            </p>
            <div className="o-hidden">
              <a href="/light/page-about2" className="rmore to-in mt-30">
                <span className="sub-title">Read More</span>
                <img
                  src="/light/assets/imgs/arrow-right.png"
                  alt=""
                  className="icon-img-20 ml-5"
                />
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 item">
            <div className="icon-img-60 mb-30">
              <img src="/light/assets/imgs/serv-icons/6.png" alt="" />
            </div>
            <h5 className="mb-15">Handover</h5>
            <p>
              Clarifying and translating insights into foundation and creative
              approach
            </p>
            <div className="o-hidden">
              <a href="/light/page-about2" className="rmore to-in mt-30">
                <span className="sub-title">Read More</span>
                <img
                  src="/light/assets/imgs/arrow-right.png"
                  alt=""
                  className="icon-img-20 ml-5"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Process;
